module.exports = "<p>\n  sexy-chexy works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/global/_directives/sexy-chexy/sexy-chexy.component.html
// module id = ./src/app/global/_directives/sexy-chexy/sexy-chexy.component.html
// module chunks = 0